import { cn } from "../lib/utils";

export const KpiCard = ({ label, value, sublabel, accent, testId }) => (
  <div
    className={cn(
      "bg-white border border-slate-200 rounded-md p-5 h-full flex flex-col justify-between",
      "hover:border-slate-300 transition-colors duration-150"
    )}
    data-testid={testId}
  >
    <div className="text-[11px] tracking-[0.08em] uppercase font-semibold text-slate-500">
      {label}
    </div>
    <div className="mt-3">
      <div
        className={cn(
          "text-2xl sm:text-3xl font-medium tabular-nums tracking-tight",
          accent === "danger" && "text-red-600",
          accent === "success" && "text-emerald-600",
          accent === "warning" && "text-amber-600",
          !accent && "text-slate-900"
        )}
      >
        {value}
      </div>
      {sublabel && <div className="text-xs text-slate-500 mt-1">{sublabel}</div>}
    </div>
  </div>
);
